import Todo from '../store/schema/Todo';
import { action } from 'satcheljs';

export const updateDefaultFolderId = action('updateDefaultFolderId', (folderId: string) => ({
    folderId,
}));

export const addTodosToFolderView = action(
    'addTodosToFolderView',
    (itemsAdded: Todo[], deleteAll: boolean = false, addToFront: boolean = false) => ({
        itemsAdded,
        deleteAll,
        addToFront,
    })
);

export const addRecentlyCompletedTodosToFolderView = action(
    'addRecentlyCompletedTodosToFolderView',
    (itemsAdded: Todo[], deleteAll: boolean = false, addToFront: boolean = false) => ({
        itemsAdded,
        deleteAll,
        addToFront,
    })
);

export const removeTodoFromView = action('removeTodoFromView', (itemId: string) => ({
    itemId,
}));

export const todosAdded = action('todosAdded');

export const insertTodosAtIndex = action(
    'insertTodosAtIndex',
    (itemsAdded: Todo[], atIndex: number) => ({
        itemsAdded,
        atIndex,
    })
);

export const updatePositions = action('updatePositions', (fromIndex: number, toIndex: number) => ({
    fromIndex,
    toIndex,
}));

export const moveFromCompletedToActiveList = action(
    'moveTodoFromCompletedToActiveList',
    (itemId: string, insertIndex: number) => ({
        itemId,
        insertIndex,
    })
);

export const moveFromActiveToCompletedList = action(
    'moveTodoFromActiveToCompletedList',
    (itemId: string) => ({
        itemId,
    })
);
